import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrophone = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M19.5 10.7996C19.5 14.9417 16.1421 18.2996 12 18.2996M12 18.2996C7.85786 18.2996 4.5 14.9417 4.5 10.7996M12 18.2996V21.8996M12 21.8996H8.1M12 21.8996H15.9M12 14.6996C9.84609 14.6996 8.1 12.9535 8.1 10.7996V5.99961C8.1 3.8457 9.84609 2.09961 12 2.09961C14.1539 2.09961 15.9 3.8457 15.9 5.99961V10.7996C15.9 12.9535 14.1539 14.6996 12 14.6996Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgMicrophone);
export { ForwardRef as ReactComponent };
